import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=539e96eb&scoped=true&"
import script from "./Products.vue?vue&type=script&lang=js&"
export * from "./Products.vue?vue&type=script&lang=js&"
import style0 from "./Products.vue?vue&type=style&index=0&id=539e96eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539e96eb",
  null
  
)

/* custom blocks */
import block0 from "./Products.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseBtn: require('/app/components/base/Btn.vue').default,BaseInput: require('/app/components/base/Input.vue').default,BaseLinkApp: require('/app/components/base/LinkApp.vue').default,BaseQrSmart: require('/app/components/base/QrSmart.vue').default})
